import { zodResolver } from "@mantine/form";
import { patientDataSchema } from "beitary-shared";
import { z } from "zod";

const patientFormSchema = patientDataSchema;

export type PatientFormValues = z.infer<typeof patientFormSchema>;

export const rules = zodResolver(patientFormSchema);
